<script lang="ts">
    import { Container, Row } from "sveltestrap";
    import Bookmark from "../../../../Layout/Breadcrumb/Bookmark.svelte";
    import Breadcrumb from "../../../../Layout/Breadcrumb/Breadcrumb.svelte";
    import { Ecommerces, Home, OrderHistory } from "../../../../utils/Constant/Constant";
</script>
<Container fluid>
    <div class="page-header">
        <Row>
            <Breadcrumb title={OrderHistory} home={Home} parent={Ecommerces} />
            <Bookmark />
        </Row>
    </div>
</Container>